<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>CI/CD</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>CI/CD</li>
        </ul>
      </div>
    </div>
  </div>